import { DsLinearFormInstanceLinkInterface } from '../interfaces/ds-linear-form-instance-link.interface';

export class DsLinearFormInstanceLink {
  /**
   *
   */
  public workId?: number;

  /**
   *
   */
  public workName?: string;

  /**
   *
   */
  public laneId?: number;

  /**
   *
   */
  public laneName?: number;

  /**
   * Creates an instance of DsLinearFormInstanceLink.
   *
   * @param jsonData Json data
   */
  constructor(jsonData: DsLinearFormInstanceLinkInterface) {
    this.workId = jsonData.workId;
    this.workName = jsonData.workName;
    this.laneId = jsonData.laneId;
    this.laneName = jsonData.laneName;
  }
}
